
import { Vue, Component } from 'vue-property-decorator'
import setting from '@/settings'
import MultiFileUpload from '@/components/busi/custom/multifileupload.vue'
import Tinymce from '@/components/Tinymce/index.vue'
import { insert, fileUploadPost } from '@/api/help'
@Component({
  name: 'create-documents',
  components: {
    Tinymce,
    MultiFileUpload
  }
})
export default class CreateDocuments extends Vue {
  // eslint-disable-next-line no-undef
  [x: string]: any
  private setting = setting

  private rules = {
    title: [
      { required: true, message: '请输入标题', trigger: 'blur' }
    ],
    content: [
      { required: true, message: '请输入标题', trigger: 'blur' }
    ]
  }

  private loading = !1

  private form: any = {
    title: '',
    content: '',
    isTop: 0,
    state: 1
  }

  private update () {
    this.iClass.hidden = !this.iClass.hidden
  }

  private async save () {
    (this.$refs.form as any).validate(async (valid: any) => {
      if (this.form.content.replace(/<[^>]*>|/g, '').trim().length < 1) {
        this.$alert('请输入内容信息')
        return
      }
      if ((this.$refs.multiUpload as any).allowUpload) {
        this.$alert('存在未上传附件！请先处理！')
        return
      }
      if (!valid) {
        (document.querySelector('#title') as any).scrollIntoView(true)
        return
      }
      const helpAtts: any = [];
      (this.$refs.multiUpload as any).datas.map((v: any) => {
        helpAtts.push({
          realName: v.realName,
          temName: v.temName,
          path: v.path,
          size: v.size
        })
      })
      valid && await insert({
        title: this.form.title,
        content: this.form.content,
        isTop: this.form.isTop,
        state: this.form.state,
        helpAtts: helpAtts
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
          this.clear()
        }
      })
    })
  }

  private clear () {
    this.form.title = ''
    this.form.content = ''
    this.form.state = 1
    this.form.isTop = 0;
    (this.$refs.multiUpload as any).clear()
  }

  private async imagesUploadHandler (blobInfo: any, succFun: any, failFun: any) {
    var formData: any = new FormData()
    formData.append('parentFolder', 'lb/schoolDetail')
    formData.append('file', blobInfo.blob(), blobInfo.filename())
    await fileUploadPost(formData).then((res: any) => {
      if (res.success) {
        const path = setting.ossIp + '/' + res.fileInfos[0].savePath
        succFun(path)
      } else {
        failFun()
      }
    })
  }
}
